import { render, staticRenderFns } from "./pagination-primary.vue?vue&type=template&id=1f9a0272&scoped=true&"
import script from "./pagination-primary.vue?vue&type=script&lang=js&"
export * from "./pagination-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a0272",
  null
  
)

export default component.exports